import { useNavigator } from '@repo/toolkit/use-navigator'
import { FamilyIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createHostFamily } from '../../../api/host-families/create-host-family'
import UserNavBar from '../../../components/elements/nav-bar'
import HostFamilyForm from '../../../components/pages/host-families/host-family-form'
import { Paths } from '../../../lib/constants/path'
import useAuth from '../../../lib/hooks/use-auth'
import { OLTypeEnum } from '../../../lib/types/enums/ol/ol-type.enum'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
import { mapHostFamilyInputToRequest } from './utils'

const HostFamilyCreatePage = () => {
  const { navigate, back } = useNavigator()
  const { user } = useAuth()
  // the authenticated user already carries its own prestataire, so no extra fetch is needed
  const showLocalRepresentative =
    user?.ol?.type === OLTypeEnum.PARTNER && !!user.ol.isOtoIndividual

  const { mutateAsync } = useMutation({
    mutationFn: createHostFamily,
    onSuccess: () => toast.success('Host family created successfully'),
    onError: showAxiosError
  })

  return (
    <div>
      <UserNavBar title={'Add a new family'} icon={FamilyIcon} />
      <div className={'h-4'} />
      <HostFamilyForm
        showLocalRepresentative={showLocalRepresentative}
        buttonsConfig={twoButtonsConfig({
          onConfirm: async (values) => {
            const res = await mutateAsync(mapHostFamilyInputToRequest(values))
            navigate(
              Paths.OL_PERSONAL_SPACE_HOST_FAMILIES_UPDATE_PAGE.replace(':id', res.id.toString()),
              { replace: true }
            )
          },
          onCancel: () => back(),
          isEnglish: true
        })}
      />
    </div>
  )
}

export default HostFamilyCreatePage
